import styled from 'styled-components';
import { COLORS } from '../../../styles/variables';
import { device } from '../../../styles/devices';
import { AlphaTheme } from '../../../../design-system/ThemeProvider/alphaTheme';

interface PaymentsWrapperProps {
  isCpoOffer: boolean;
  isFeatured?: boolean;
}

export const TileWrapper = styled.div<{ isCpoOffer: boolean; isAlpha?: boolean }>`
  width: 339px;
  background-color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.cardSurface ?? COLORS.white};
  border-radius: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.borderRadiusSm ?? '0'};
  overflow: hidden;
  padding: 24px 24px 12px 24px;
  min-height: ${({ isCpoOffer }) => (isCpoOffer ? '733px' : '855px')};
  /* min-height: 255px; */
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  @media ${device.tablet} {
    ${({ isAlpha }) => isAlpha && 'width: 575px;'}
  }
`;

export const TagAndDagWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
`;

export const DagLabel = styled.p``;

export const NameAndTrimWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  min-height: 64px;
`;

export const ImageWrapper = styled.div<{ isCpoOffer: boolean }>`
  margin: ${({ isCpoOffer }) => (isCpoOffer ? '16px 0 8px 0' : '16px 0')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ImageWrapperAlpha = styled.div<{ imageUrl?: string; isCpoOffer: boolean }>`
  margin: ${({ isCpoOffer }) => (isCpoOffer ? '16px 0 8px 0' : '16px 0')};
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
  aspect-ratio: 16/9;
  height: 163.688px;
  border-radius: var(--Sys-BorderRadius-None, 0);
  background: ${({ imageUrl }) => (imageUrl ? `url(${imageUrl})` : 'none')} 50% / cover no-repeat;

  @media ${device.tablet} {
    height: 296.438px;
  }
`;

export const VehicleImage = styled.img`
  width: 260px;
  height: 154px;
  object-fit: cover;
  scale: 1.1;
  @media ${device.mobileL} {
    width: 296px;
  }
`;

export const ImageDiscalimer = styled.p`
  font-size: 10px;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.foregroundNeutral200 ?? 'inherit'};
`;

export const VehicleInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CpoOffersWrapper = styled.div<{ isModal?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: ${({ isModal }) => (isModal ? '24px' : '12px')};
`;

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding-top: 16px;
`;

export const Price = styled.div`
  position: relative;
`;

export const CpoLabelWrapper = styled.div`
  padding-bottom: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const OfferInfo = styled.div<{ isCpoOffer: boolean }>`
  padding: 16px 0;
  width: 100%;
  min-height: ${({ isCpoOffer }) => (isCpoOffer ? '164px' : '297px')};
`;

export const PaymentsWrapper = styled.div<PaymentsWrapperProps>`
  display: flex;
  flex-direction: column;
  gap: ${({ isCpoOffer, isFeatured }) => {
    if (isFeatured) return '8px';
    if (isCpoOffer) return '12px';
    return '16px';
  }};
  @media ${device.tablet} {
    width: 100%;
  }
`;

export const PricingOptionsWrapper = styled.div`
  flex: 1;
`;

export const ExpiryDetails = styled.div<{ marginTop?: string }>`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  /* margin-top: 12px; */
`;

export const ExpiryDetailsAlpha = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 32px;
  @media ${device.tablet} {
    justify-content: space-between;
  }
`;

export const Divider = styled.div`
  width: 1px;
  background-color: ${COLORS.grey15};
`;

export const PaymentsTileContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const MainOffer = styled.div<{ isModal?: boolean }>`
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.foregroundNeutral100 ?? COLORS.grey80};
  display: flex;
  flex-direction: row;
  gap: ${({ isModal }) => (isModal ? '24px' : '16px')};

  .MainOffer-alpha {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }

  @media ${device.tablet} {
    justify-content: center;
  }
`;
export const PercentData = styled.div<{ isFeatured?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: ${({ isFeatured }) => (isFeatured ? '135px' : '125px')};
`;
export const PaymentData = styled.div<{ isFeatured?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: ${({ isFeatured }) => (isFeatured ? '135px' : '125px')};
  margin-top: inherit !important;
`;

export const CreditBonus = styled.div<{ isFeatured?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding-top: ${({ isFeatured }) => isFeatured && '8px'};
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.foregroundNeutral100 ?? 'inherit'};
`;
export const Extra = styled.div`
  /* padding: 16px 0; */
  p {
    color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
      theme.foregroundNeutral200 ?? COLORS.grey60};
  }
`;

export const ExpiryTextWrapper = styled.div``;

export const OfferModalCta = styled.div`
  flex-shrink: 0;
  white-space: nowrap;
`;

export const PriceDisclaimer = styled.p`
  padding-top: 8px;
  font-size: 12px;
  text-align: center;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.foregroundNeutral200 ?? 'inherit'};
`;

export const WhyBuy = styled.div<{ disabledCta?: boolean; isAlpha?: boolean }>`
  margin-top: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-bottom: ${({ isAlpha }) => (isAlpha ? '16px' : '0')};

  a,
  button {
    pointer-events: ${({ disabledCta }) => (disabledCta ? 'none' : 'auto')};
    cursor: ${({ disabledCta }) => (disabledCta ? 'not-allowed' : 'pointer')};
    color: ${({ disabledCta, theme }: { disabledCta?: boolean; theme: Partial<AlphaTheme> }) =>
      disabledCta
        ? (theme.foregroundDisabled100 ?? COLORS.grey30)
        : (theme.foregroundNeutral100 ?? COLORS.black)};
    text-decoration-color: currentColor;
    svg {
      opacity: ${({ disabledCta }) => (disabledCta ? '0.3' : '1')};
    }
  }
`;

export const CpoOffer = styled.div`
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.foregroundNeutral100 ?? COLORS.grey80};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;
export const Apr = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.foregroundNeutral200 ?? 'inherit'};
`;
export const Percent = styled.div`
  /* font-weight: 700; */
  position: relative;
`;

export const Term = styled.div`
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.foregroundNeutral200 ?? 'inherit'};
  /* display: flex;
  flex-direction: column;
  align-items: center; */
`;

export const SuperScript = styled.div`
  position: absolute;
  /* width: 24px;
  height: 24px; */
  top: -12px;
  right: -24px;
  .link {
    padding: 12px;
  }
`;
